"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterPillHeaderContainer = exports.getPills = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var FilterPillHeader_1 = require("../../react/components/FilterPillHeader");
var Contexts_1 = require("../Contexts");
var AdvancedFilter_1 = require("../utilities/AdvancedFilter");
var Ioc_1 = require("../utilities/Ioc");
var getPills = function (filters, onRemoveFilter, onOnlineButtonClicked) {
    var pills = [];
    if (filters === null || filters === void 0 ? void 0 : filters.advanced) {
        // don't render pills for "locked" filters
        filters.advanced
            .filter(function (filter) { return !filter.isLocked; })
            .forEach(function (advancedFilter) {
            advancedFilter.options.forEach(function (option) {
                if (option.isChecked && !option.isLocked) {
                    pills.push({
                        onFilterClose: function () {
                            onRemoveFilter(advancedFilter.name, option.value);
                            onOnlineButtonClicked();
                        },
                        label: option.label,
                        // TODO: how the fuck does this work without the translate and tracking props?
                    });
                }
            });
        });
    }
    return pills;
};
exports.getPills = getPills;
var FilterPillHeaderContainer = function (_a) {
    var emitTrackingEvent = _a.emitTrackingEvent, filters = _a.filters, isMobile = _a.isMobile, onRemoveFilter = _a.onRemoveFilter, onOnlineButtonClicked = _a.onOnlineButtonClicked;
    var _b = __read((0, Ioc_1.useContexts)(Contexts_1.ITranslationServiceContext), 1), translate = _b[0].translate;
    return ((0, jsx_runtime_1.jsx)(FilterPillHeader_1.FilterPillHeader, { emitTrackingEvent: emitTrackingEvent, isMobile: isMobile, onClearFiltersClicked: function () {
            emitTrackingEvent("icfClick", "clearFilters", "label=".concat(isMobile ? "mobile" : "desktop"));
            (0, AdvancedFilter_1.getClearFiltersCallback)(filters, onRemoveFilter)();
            onOnlineButtonClicked();
        }, pills: (0, exports.getPills)(filters, onRemoveFilter, onOnlineButtonClicked), translate: translate }));
};
exports.FilterPillHeaderContainer = FilterPillHeaderContainer;
exports.FilterPillHeaderContainer.displayName = "FilterPillHeaderContainer";
//# sourceMappingURL=FilterPillHeaderContainer.js.map